import { Visibility, VisibilityOff } from '@mui/icons-material'
import { TextField, FormControl, InputLabel, Input, InputAdornment, IconButton, Box, Button, Alert } from '@mui/material'
import { signInWithEmailAndPassword } from 'firebase/auth'
import { FirebaseError } from 'firebase/app'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { auth } from '../../firebase/init'

type Props = {
  from: string
}
const SignIn: React.FC<Props> = ({from}) => {
  const navigate = useNavigate()
  const [form_data, setFormData] = useState<{
    email: string, password: string
  }>({email: '', password: ''})
  const [password_visible, setPasswordVisible] = useState(false)
  const [error_message, setErrorMessage] = useState('')

  return <form
    onSubmit={async e=> {
      e.preventDefault()
      setErrorMessage('')
      const form_data = new FormData(e.currentTarget)
      const email = form_data.get('email') as string
      const password = form_data.get('password') as string

      try {
        await signInWithEmailAndPassword(auth, email, password)
        navigate(from)
      } catch (err) {
        if (err instanceof FirebaseError) {
          console.error(err.code, err.message)
          switch (err.code) {
          case 'auth/wrong-password':
          case 'auth/invalid-credential':
            setErrorMessage('パスワードが間違っています')
            break
          case 'auth/user-not-found':
            setErrorMessage('このメールアドレスは登録されていません')
            break
          case 'auth/invalid-email':
            setErrorMessage('メールアドレスの形式が正しくありません')
            break
          case 'auth/too-many-requests':
            setErrorMessage('ログイン試行回数が多すぎます。しばらくしてから再度お試しください')
            break
          default:
            setErrorMessage('ログインに失敗しました。もう一度お試しください')
          }
        } else {
          setErrorMessage('ログインに失敗しました。もう一度お試しください')
        }
      }
    }}
  >
    {error_message && (
      <Alert severity="error" sx={{ mt: 2, mb: 2 }}>
        {error_message}
      </Alert>
    )}
    <TextField
      variant='standard' fullWidth
      name='email' type='text' label='Email'
      autoComplete='email'
      value={form_data.email}
      onChange={e=> { setFormData({...form_data, email: e.target.value}) }}
      placeholder='Username' required
      sx={{mt: 2}}
    />

    <FormControl variant='standard' sx={{mt: 2}} fullWidth>
      <InputLabel htmlFor="password">Password</InputLabel>
      <Input
        name='password'
        id='password'
        type={password_visible ? 'text' : 'password'}
        autoComplete='current-password'
        placeholder='Password' required
        value={form_data.password}
        onChange={e=> { setFormData({...form_data, password: e.target.value}) }}
        endAdornment={
          <InputAdornment position='end'>
            <IconButton
              onClick={()=> { setPasswordVisible(!password_visible) }}
            >
              {password_visible ? <Visibility/> : <VisibilityOff/>}
            </IconButton>
          </InputAdornment>
        }
      />
    </FormControl>

    <Box textAlign='center'>
      <Button
        disabled={Object.values(form_data).some(v=> v === '')}
        type='submit' variant='contained' color='primary'
        sx={{mt: 4}}
      >
        ログイン
      </Button>
    </Box>
  </form>
}
export default SignIn